import "core-js/modules/es.array.reverse.js";
var _class, _descriptor, _InfoParameter;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { makeObservable, observable, override } from "mobx";
import isDefined from "../../Core/isDefined";
import FunctionParameter from "./FunctionParameter";
/**
 * Function Parameter for showing information - this makes no changes to `parameters`, all values are stored locally.
 */
let InfoParameter = (_class = (_InfoParameter = class InfoParameter extends FunctionParameter {
  constructor(catalogFunction, options) {
    super(catalogFunction, options);
    _defineProperty(this, "type", "info");
    _initializerDefineProperty(this, "_value", _descriptor, this);
    _defineProperty(this, "_errorMessage", false);
    makeObservable(this);
    if (isDefined(options.value)) {
      this._value = options.value;
    }
    if (isDefined(options.errorMessage)) {
      this._errorMessage = options.errorMessage;
    }
  }
  get isValid() {
    return !this._errorMessage;
  }
  get value() {
    return this._value;
  }
  setValue(_strataId, v) {
    this._value = v;
  }
  clearValue(_strataId) {
    this._value = undefined;
  }
}, _defineProperty(_InfoParameter, "type", "info"), _InfoParameter), _descriptor = _applyDecoratedDescriptor(_class.prototype, "_value", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "isValid", [override], Object.getOwnPropertyDescriptor(_class.prototype, "isValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "value", [override], Object.getOwnPropertyDescriptor(_class.prototype, "value"), _class.prototype), _class);
export { InfoParameter as default };